/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Reseller_Pricing_SavedInputs */

const id_reseller_pricing_saved = /** @type {(inputs: Reseller_Pricing_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Harga jual ${i?.tld} disimpan.`)
};

const en_reseller_pricing_saved = /** @type {(inputs: Reseller_Pricing_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selling prices for ${i?.tld} saved.`)
};

/**
* | output |
* | --- |
* | "Selling prices for {tld} saved." |
*
* @param {Reseller_Pricing_SavedInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_saved = /** @type {((inputs: Reseller_Pricing_SavedInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_SavedInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_saved(inputs)
	return id_reseller_pricing_saved(inputs)
});